/**
 * Shared debug flag for all mock API implementations.
 * Enable to trace mock API calls during local development:
 *
 *   import { MockDebug } from '@series-inc/rundot-game-sdk'
 *   MockDebug.enabled = true
 */
export const MockDebug = { enabled: false }

export function mockLog(tag: string, message: string, ...args: unknown[]): void {
  if (MockDebug.enabled) console.log(`[${tag}] ${message}`, ...args)
}
